import * as React from 'react';
import { useBondsBondIsSomeRedacted, useAmountFor } from '../../hooks';
import { ActorApiStringDisplay } from '../../../../../../components/display/string';

export const NetAmountFor = (props: {
  nominal: number,
  tob?: boolean,
  withRedactedIcon?: boolean,
}) => {
  const {
    nominal,
    tob,
    withRedactedIcon,
  } = props;
  const {
    data,
    isLoading,
    error,
  } = useAmountFor(nominal, tob);
  const {
    data: redacted,
    isLoading: redactedIsLoading,
  } = useBondsBondIsSomeRedacted([
    'S_QUOTE.PRICE_CLOSE',
    'S_QUOTE.PRICE_MAX',
    'S_ACC.INT_RATE',
    'S_ACC.OBL_END_DATE',
    'S_ACC.OBL_END_PRICE',
    'S_ACC_JRS.FREQ',
    'S_ACC.ISSUE_DATE',
    'S_ACC.OBL_FIRST_CPS',
  ]);
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading || redactedIsLoading}
      error={error}
      isBlocked={redacted}
      withRedactedIcon={withRedactedIcon}
      loadingValue="-- ---.-- ---"
    />
  );
};
